import React from 'react';
import { Field } from '@progress/kendo-react-form';
import { FormComboBox } from '../../fields/FormComboBox';
import { FormDropDownList } from '../../fields/FormDropdown';
import { getRequiredValidator, isFieldOptional, isSearchableExtDictionary } from '../fieldMapperHelpers';
import { FieldMapperContext } from '../fieldMapperTypes';

export function renderChoiceField(ctx: FieldMapperContext): React.ReactElement {
  const {
    ctField,
    fieldLabel,
    choices,
    fieldDisabled,
    handleChange,
    isLoading,
    onChange,
    onFilterChange,
    showSearchButton
  } = ctx;

  if (isSearchableExtDictionary(ctField)) {
    return (
      <Field
        key={ctField.name}
        name={ctField.name}
        component={FormComboBox}
        choices={choices}
        label={fieldLabel}
        defaultValue={ctField.defaultValue}
        validator={getRequiredValidator(ctField)}
        optional={isFieldOptional(ctField)}
        onFilterChange={(value: string) => onFilterChange?.(value)}
        onSelectionChange={(value: unknown) => onChange?.(value)}
        showSearchButton={showSearchButton}
        disabled={fieldDisabled}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Field
      key={ctField.name}
      name={ctField.name}
      component={FormDropDownList}
      data={choices}
      label={fieldLabel}
      defaultValue={ctField.defaultValue}
      validator={getRequiredValidator(ctField)}
      optional={isFieldOptional(ctField)}
      onChange={handleChange}
      disabled={fieldDisabled}
      isLoading={isLoading}
    />
  );
}
